module.exports = __webpack_public_path__ + "static/media/logoCompany.a8c2861f.svg";